<h2 mat-dialog-title>
  <span class="dialog-title">AI Assistant - {{transactionName}}</span>
  <button mat-icon-button mat-dialog-close class="close-btn" (click)="closepopup()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <p>Use AI to process documents and assist with care documentation for {{transactionName}}.</p>
  <br>

    <!-- Upload Document -->
  <!-- <div class="upload-container" (click)="fileInput.click()">
    <input #fileInput type="file" multiple hidden (change)="onFileSelected($event)" />
    <div class="upload-box">
      <mat-icon>cloud_upload</mat-icon>
      <p>Click to upload or drag and drop</p>
    </div>
  </div> -->

  <div class="upload-container"
     (click)="fileInput.click()"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave($event)"
     (drop)="onDrop($event)">
  <input #fileInput type="file" multiple hidden (change)="onFileSelected($event)" />
  <div class="upload-box" [class.dragover]="isDragging">
    <mat-icon>cloud_upload</mat-icon>
    <p>Click to upload or drag and drop</p>
  </div>
</div>


 <!-- Uploaded Document List -->
  <div *ngIf="uploadedFiles.length > 0" class="file-list">
  <h4 class="file-list-title">Uploaded Documents</h4>
  <div class="file-item" *ngFor="let file of uploadedFiles; let i = index">
    <div class="file-info">
      <mat-icon class="file-icon">insert_drive_file</mat-icon>
      <div>
        <div class="file-name">{{ file.name }}</div>
        <div class="file-size">{{ file.size / 1024 | number:'1.0-0' }} KB</div>
      </div>
    </div>
    <button mat-icon-button color="warn" (click)="removeFile(i)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
 <br>
<!-- <br>
  <p class="ai-automation-text">
  For Run AI Automation, select automation templates.
 </p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Select Category</mat-label>
    <mat-select value="My Template">
      <mat-option value="My Template">My Template</mat-option>
    </mat-select>
  </mat-form-field> -->

   <mat-form-field appearance="outline" class="full-width">
    <mat-label>Select Automation Template</mat-label>
    <mat-select (selectionChange)="onTemplateSelect($event)">
      <mat-option *ngFor="let fn of aITemplateList" [value]="fn.aiAutomationTemplateID">
        {{ fn.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions class="center-actions">
  <button  [disabled]="uploadedFiles.length === 0" mat-flat-button color="primary" (click)="processWithAI()">
    Process with AI
  </button>
  
</mat-dialog-actions>

